import { createFileRoute } from '@tanstack/react-router'

import { CampaignJoinPage } from '@/features/campaigns'

export const Route = createFileRoute('/_authenticated/_main/campanhas/ingresso')({
  component: CampaignJoinPage
})
